import { getActivityCodeDescendants, getActivityCodeAncestors } from '../util/ActivityCodeLogic.jsx';
import { filterProjectActivities } from '../util/FilterLogic.jsx';

export const blankFilter = {
	flags: {},
	searchText: '',
	activityStatus: {},
	activityCodes: {},
	useDynamicDates: false,
	startDate: 0,
	endDate: 0,
	dynamicRange: '',
	floatMin: 0,
	floatMax: 0,
	applyFloatFilter: false,
	resources: {},
	hasPhotos: false,
	changes: false
};

export const PROJECT_FILTER_ACTION_TYPES = {
	SET_PROJECT_FILTER_FROM_LAYOUT: 'SET_PROJECT_FILTER_FROM_LAYOUT',
	SET_PROJECT_FILTER_SEARCH_TEXT: 'SET_PROJECT_FILTER_SEARCH_TEXT',
	SET_PROJECT_FILTER_STATUS: 'SET_PROJECT_FILTER_STATUS',
	SET_PROJECT_FILTER_ACTIVITY_CODE: 'SET_PROJECT_FILTER_ACTIVITY_CODE',
	SET_PROJECT_FILTER_START_DATE: 'SET_PROJECT_FILTER_START_DATE',
	SET_PROJECT_FILTER_END_DATE: 'SET_PROJECT_FILTER_END_DATE',
	SET_PROJECT_FILTER_DATES: 'SET_PROJECT_FILTER_DATES',
	SET_PROJECT_FILTER_USE_DYNAMIC_DATES: 'SET_PROJECT_FILTER_USE_DYNAMIC_DATES',
	SET_PROJECT_FILTER_DYNAMIC_RANGE: 'SET_PROJECT_FILTER_DYNAMIC_RANGE',
	SET_PROJECT_FILTER_FLOAT: 'SET_PROJECT_FILTER_FLOAT',
	SET_PROJECT_FILTER_APPLY_FLOAT_FILTER: 'SET_PROJECT_FILTER_APPLY_FLOAT_FILTER',
	SET_PROJECT_FILTER_RESOURCES: 'SET_PROJECT_FILTER_RESOURCES',
	SET_PROJECT_FILTER_FLAG: 'SET_PROJECT_FILTER_FLAG',
	SET_PROJECT_FILTER_HAS_PHOTOS: 'SET_PROJECT_FILTER_HAS_PHOTOS',
	SET_PROJECT_FILTER_CHANGES: 'SET_PROJECT_FILTER_CHANGES',
	SET_PROJECT_FILTER_RESET: 'SET_PROJECT_FILTER_RESET'
};

export const setProjectFilterFromLayout = () => {
	return {
		type: PROJECT_FILTER_ACTION_TYPES.SET_PROJECT_FILTER_FROM_LAYOUT,
		payload: {}
	};
};

export const setProjectFilterSearchText = searchText => {
	return {
		type: PROJECT_FILTER_ACTION_TYPES.SET_PROJECT_FILTER_SEARCH_TEXT,
		payload: { searchText }
	};
};

export const setProjectFilterStatus = (statusCode, isChecked) => {
	return {
		type: PROJECT_FILTER_ACTION_TYPES.SET_PROJECT_FILTER_STATUS,
		payload: { statusCode, isChecked }
	};
};

export const setProjectFilterActivityCode = (activityCode, activityCodeTypeId, isChecked) => {
	return {
		type: PROJECT_FILTER_ACTION_TYPES.SET_PROJECT_FILTER_ACTIVITY_CODE,
		payload: { activityCode, activityCodeTypeId, isChecked }
	};
};

export const setProjectFilterStartDate = (startDate) => {
	return {
		type: PROJECT_FILTER_ACTION_TYPES.SET_PROJECT_FILTER_START_DATE,
		payload: { startDate }
	};
};

export const setProjectFilterEndDate = (endDate) => {
	return {
		type: PROJECT_FILTER_ACTION_TYPES.SET_PROJECT_FILTER_END_DATE,
		payload: { endDate }
	};
};

export const setProjectFilterDates = (startDate, endDate) => {
	return {
		type: PROJECT_FILTER_ACTION_TYPES.SET_PROJECT_FILTER_DATES,
		payload: { startDate, endDate }
	};
};

export const setProjectFilterUseDynamicDates = (useDynamicDates) => {
	return {
		type: PROJECT_FILTER_ACTION_TYPES.SET_PROJECT_FILTER_USE_DYNAMIC_DATES,
		payload: { useDynamicDates }
	};
};

export const setProjectFilterDynamicRange = (dynamicRange) => {
	return {
		type: PROJECT_FILTER_ACTION_TYPES.SET_PROJECT_FILTER_DYNAMIC_RANGE,
		payload: { dynamicRange }
	};
};

export const setProjectFilterFloat = (floatMin, floatMax) => {
	return {
		type: PROJECT_FILTER_ACTION_TYPES.SET_PROJECT_FILTER_FLOAT,
		payload: { floatMin, floatMax }
	};
};

export const setProjectFilterApplyFloatFilter = (applyFloatFilter) => {
	return {
		type: PROJECT_FILTER_ACTION_TYPES.SET_PROJECT_FILTER_APPLY_FLOAT_FILTER,
		payload: { applyFloatFilter }
	};
};

export const setProjectFilterResources = (resource, isChecked) => {
	return {
		type: PROJECT_FILTER_ACTION_TYPES.SET_PROJECT_FILTER_RESOURCES,
		payload: { resource, isChecked }
	};
};

export const setProjectFilterFlag = (flagCode, isChecked) => {
	return {
		type: PROJECT_FILTER_ACTION_TYPES.SET_PROJECT_FILTER_FLAG,
		payload: { flagCode, isChecked }
	};
};

export const setProjectFilterHasPhotos = (isChecked) => {
	return {
		type: PROJECT_FILTER_ACTION_TYPES.SET_PROJECT_FILTER_HAS_PHOTOS,
		payload: { isChecked }
	};
};

export const setProjectFilterChanges = (isChecked) => {
	return {
		type: PROJECT_FILTER_ACTION_TYPES.SET_PROJECT_FILTER_CHANGES,
		payload: { isChecked }
	};
};

export const setProjectFilterReset = () => {
	return {
		type: PROJECT_FILTER_ACTION_TYPES.SET_PROJECT_FILTER_RESET,
		payload: {}
	};
};

/** True when any filter dimension differs from a cleared blank filter. */
export const isProjectFilterActive = projectFilter => {
	if (!projectFilter) {
		return false;
	}
	if (Object.keys(projectFilter.flags || {}).length) {
		return true;
	}
	if (projectFilter.searchText) {
		return true;
	}
	if (Object.keys(projectFilter.activityStatus || {}).length) {
		return true;
	}
	for (const typeId in projectFilter.activityCodes || {}) {
		if (Object.keys(projectFilter.activityCodes[typeId]).length) {
			return true;
		}
	}
	if (projectFilter.useDynamicDates && projectFilter.dynamicRange) {
		return true;
	}
	if (projectFilter.startDate || projectFilter.endDate) {
		return true;
	}
	if (projectFilter.applyFloatFilter) {
		return true;
	}
	if (Object.keys(projectFilter.resources || {}).length) {
		return true;
	}
	if (projectFilter.hasPhotos) {
		return true;
	}
	if (projectFilter.changes) {
		return true;
	}
	return false;
};

export default (state, action) => {
	const { type, payload } = action;
	switch (type) {
		// TODO: Is this ever used? I think it was replaced by PROJECT_LAYOUT_SET in projectLayout.js
		case PROJECT_FILTER_ACTION_TYPES.SET_PROJECT_FILTER_FROM_LAYOUT: {
			const { projectLayouts, projectLayoutId } = state;
			const layout = projectLayouts.find(layout => layout.Id === projectLayoutId);

			const newState = {
				...state,
				projectFilter: layout && layout.Filter ? {...layout.Filter} : JSON.parse(JSON.stringify(blankFilter))
			};
			return {
				...newState,
				...filterProjectActivities(newState)
			};
		}
		case PROJECT_FILTER_ACTION_TYPES.SET_PROJECT_FILTER_SEARCH_TEXT: {
			// trackEvent('filter', 'type', 'filter search text');
			const newState = {
				...state,
				layoutChanged: true,
				projectFilter: {
					...state.projectFilter,
					searchText: payload.searchText
				}
			};
			return {
				...newState,
				...filterProjectActivities(newState)
			};
		}
		case PROJECT_FILTER_ACTION_TYPES.SET_PROJECT_FILTER_STATUS: {
			// trackEvent('filter', 'click', 'filter status');
			const activityStatus = Object.assign({}, state.projectFilter.activityStatus);
			if (payload.isChecked) {
				activityStatus[payload.statusCode] = true;
			} else {
				delete activityStatus[payload.statusCode];
			}
			const newState = {
				...state,
				layoutChanged: true,
				projectFilter: {
					...state.projectFilter,
					activityStatus
				}
			};
			return {
				...newState,
				...filterProjectActivities(newState)
			};
		}
		case PROJECT_FILTER_ACTION_TYPES.SET_PROJECT_FILTER_ACTIVITY_CODE: {
			// trackEvent('filter', 'click', 'filter activity code');
			const { activityCode, activityCodeTypeId, isChecked } = payload;
			const { projectFilter, projectActivityCodesRelativesMap } = state;
			const datasetInfo = state.currentDataset && state.datasets ? state.datasets[state.currentDataset] : null;
			if (!datasetInfo || !datasetInfo.filterOptions) {
				return state;
			}
			const { filterOptions } = datasetInfo;

			const projectFilterActivityCodes = Object.assign({}, projectFilter.activityCodes);

			if (!(activityCodeTypeId in projectFilterActivityCodes)) {
				projectFilterActivityCodes[activityCodeTypeId] = {};
			} else {
				projectFilterActivityCodes[activityCodeTypeId] = Object.assign(
					{},
					projectFilterActivityCodes[activityCodeTypeId]
				);
			}

			if (activityCode === null) {
				const codes = filterOptions.activityCodeTypeActivityCodes[activityCodeTypeId];
				if (isChecked) {
					for (let i = 0; i < codes.length; i++) {
						projectFilterActivityCodes[activityCodeTypeId][codes[i]] = true;
					}
				} else {
					for (let i = 0; i < codes.length; i++) {
						delete projectFilterActivityCodes[activityCodeTypeId][codes[i]];
					}
				}
			} else {
				const descendants = getActivityCodeDescendants(activityCode, projectActivityCodesRelativesMap.children[activityCodeTypeId]);
				const ancestors = getActivityCodeAncestors(activityCode, projectActivityCodesRelativesMap.parents[activityCodeTypeId]);

				if (isChecked) {
					//check this one
					projectFilterActivityCodes[activityCodeTypeId][activityCode] = true;

					//also check all descendants if any exist
					for (const descendantActivityCode in descendants) {
						projectFilterActivityCodes[activityCodeTypeId][descendantActivityCode] = true;
					}
					//check each ancestor if all of that ancestor's descendants are checked
					for (const ancestorActivityCode in ancestors) {
						const ancestorDescendants = getActivityCodeDescendants(ancestorActivityCode, projectActivityCodesRelativesMap.children[activityCodeTypeId]);
						let allAncestorDescendantsChecked = true;
						for (const ancestorDescendantActivityCode in ancestorDescendants) {
							if (!(ancestorDescendantActivityCode in projectFilterActivityCodes[activityCodeTypeId])) {
								allAncestorDescendantsChecked = false;
								break;
							}
						}
						if (allAncestorDescendantsChecked) {
							projectFilterActivityCodes[activityCodeTypeId][ancestorActivityCode] = true;
						} else {
							break;
						}
					}
				} else {
					//uncheck this one
					delete projectFilterActivityCodes[activityCodeTypeId][activityCode];

					//also uncheck all children if any exist
					for (const descendantActivityCode in descendants) {
						delete projectFilterActivityCodes[activityCodeTypeId][descendantActivityCode];
					}
					//also uncheck all ancestors
					for (const ancestorActivityCode in ancestors) {
						delete projectFilterActivityCodes[activityCodeTypeId][ancestorActivityCode];
					}
				}
			}

			const newState = {
				...state,
				layoutChanged: true,
				projectFilter: {
					...state.projectFilter,
					activityCodes: projectFilterActivityCodes
				}
			};
			return {
				...newState,
				...filterProjectActivities(newState)
			};
		}
		case PROJECT_FILTER_ACTION_TYPES.SET_PROJECT_FILTER_START_DATE: {
			// trackEvent('filter', 'click', 'filter start date');
			const newState = {
				...state,
				layoutChanged: true,
				projectFilter: {
					...state.projectFilter,
					startDate: payload.startDate
				}
			};
			return {
				...newState,
				...filterProjectActivities(newState)
			};
		}
		case PROJECT_FILTER_ACTION_TYPES.SET_PROJECT_FILTER_END_DATE: {
			// trackEvent('filter', 'click', 'filter end date');
			const newState = {
				...state,
				layoutChanged: true,
				projectFilter: {
					...state.projectFilter,
					endDate: payload.endDate
				}
			};
			return {
				...newState,
				...filterProjectActivities(newState)
			};
		}
		case PROJECT_FILTER_ACTION_TYPES.SET_PROJECT_FILTER_DATES: {
			// trackEvent('filter', 'click', 'filter start/end dates');
			const newState = {
				...state,
				layoutChanged: true,
				projectFilter: {
					...state.projectFilter,
					useDynamicDates: false,
					startDate: payload.startDate,
					endDate: payload.endDate
				}
			};
			return {
				...newState,
				...filterProjectActivities(newState)
			};
		}
		case PROJECT_FILTER_ACTION_TYPES.SET_PROJECT_FILTER_USE_DYNAMIC_DATES: {
			// trackEvent('filter', 'click', 'filter dynamic dates');
			const newState = {
				...state,
				layoutChanged: true,
				projectFilter: {
					...state.projectFilter,
					useDynamicDates: payload.useDynamicDates
				}
			};
			return {
				...newState,
				...filterProjectActivities(newState)
			};
		}
		case PROJECT_FILTER_ACTION_TYPES.SET_PROJECT_FILTER_DYNAMIC_RANGE: {
			// trackEvent('filter', 'click', 'filter dynamic range');
			const newState = {
				...state,
				layoutChanged: true,
				projectFilter: {
					...state.projectFilter,
					dynamicRange: payload.dynamicRange
				}
			};
			return {
				...newState,
				...filterProjectActivities(newState)
			};
		}
		case PROJECT_FILTER_ACTION_TYPES.SET_PROJECT_FILTER_FLOAT: {
			// trackEvent('filter', 'click', 'filter float');
			const newState = {
				...state,
				layoutChanged: true,
				projectFilter: {
					...state.projectFilter,
					floatMin: payload.floatMin,
					floatMax: payload.floatMax
				}
			};
			return {
				...newState,
				...filterProjectActivities(newState)
			};
		}
		case PROJECT_FILTER_ACTION_TYPES.SET_PROJECT_FILTER_APPLY_FLOAT_FILTER: {
			// trackEvent('filter', 'click', 'filter apply float');
			const newState = {
				...state,
				layoutChanged: true,
				projectFilter: {
					...state.projectFilter,
					applyFloatFilter: payload.applyFloatFilter
				}
			};
			return {
				...newState,
				...filterProjectActivities(newState)
			};
		}
		case PROJECT_FILTER_ACTION_TYPES.SET_PROJECT_FILTER_RESOURCES: {
			// trackEvent('filter', 'click', 'filter resources');
			const resources = Object.assign({}, state.projectFilter.resources);
			if (payload.isChecked) {
				resources[payload.resource] = true;
			} else {
				delete resources[payload.resource];
			}
			const newState = {
				...state,
				layoutChanged: true,
				projectFilter: {
					...state.projectFilter,
					resources
				}
			};
			return {
				...newState,
				...filterProjectActivities(newState)
			};
		}
		case PROJECT_FILTER_ACTION_TYPES.SET_PROJECT_FILTER_FLAG: {
			// trackEvent('filter', 'click', 'filter flag');
			const flags = Object.assign({}, state.projectFilter.flags);
			if (payload.isChecked) {
				flags[payload.flagCode] = true;
			} else {
				delete flags[payload.flagCode];
			}
			const newState = {
				...state,
				layoutChanged: true,
				projectFilter: {
					...state.projectFilter,
					flags
				}
			};
			return {
				...newState,
				...filterProjectActivities(newState)
			};
		}
		case PROJECT_FILTER_ACTION_TYPES.SET_PROJECT_FILTER_HAS_PHOTOS: {
			// trackEvent('filter', 'click', 'filter has photos');
			const newState = {
				...state,
				layoutChanged: true,
				projectFilter: {
					...state.projectFilter,
					hasPhotos: payload.isChecked
				}
			};
			return {
				...newState,
				...filterProjectActivities(newState)
			};
		}
		case PROJECT_FILTER_ACTION_TYPES.SET_PROJECT_FILTER_CHANGES: {
			// trackEvent('filter', 'click', 'filter changes');
			const newState = {
				...state,
				layoutChanged: true,
				projectFilter: {
					...state.projectFilter,
					changes: payload.isChecked
				}
			};
			return {
				...newState,
				...filterProjectActivities(newState)
			};
		}
		case PROJECT_FILTER_ACTION_TYPES.SET_PROJECT_FILTER_RESET: {
			// trackEvent('filter', 'click', 'filter changes');
			const newState = {
				...state,
				projectFilter: JSON.parse(JSON.stringify(blankFilter)),
				layoutChanged: false
			};
			return {
				...newState,
				...filterProjectActivities(newState)
			};
		}
		default:
			console.log('action type not found: ', type);
			return state;
	}
};
